import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { withParams } from '@telialt/utils/src/helpers';

import { RemoveAction } from '../components/RemoveAction';
import { TooltipInfo } from '../components/TooltipInfo/TooltipInfo';
import { ORDER_CART_ENTRY_ID, ORDER_CART_TEST_ID } from '../constants';
import { Price } from '../model';
import {
    CellDetailSecondary,
    CellIcon,
    CellPrice,
    CellTitle,
    InsuranceEntryListItem,
    WithTooltip,
} from './entries.styles';

type InsuranceEntryProps = {
    monthlyPrice: Price;
    franchisePrice: Price;
    freePeriod: number;
    footNote?: string;
    onRemove?: () => void;
    isLoading?: boolean;
    isDisabled?: boolean;
};

export const InsuranceEntry: FC<InsuranceEntryProps> = ({
    monthlyPrice,
    franchisePrice,
    freePeriod,
    footNote,
    onRemove,
    isLoading,
    isDisabled,
}) => {
    const { t } = useTranslations();

    const title = t['order_cart.entry_insurance.title'];
    const tooltipText = withParams(t['order_cart.entry_insurance.tooltip_text'], {
        freePeriod,
        'freePeriod+1': freePeriod + 1,
        monthlyPrice: monthlyPrice.formattedValue,
        franchisePrice: franchisePrice.formattedValue,
    });
    const note = withParams(footNote || t['order_cart.entry_insurance.note'], {
        freePeriod,
        monthlyPrice: monthlyPrice.formattedValue,
    });

    return (
        <InsuranceEntryListItem data-test={ORDER_CART_ENTRY_ID.INSURANCE} aria-label={title}>
            <CellIcon icon="secured-2" />
            <CellTitle data-test={ORDER_CART_TEST_ID.ENTRY_TITLE_INSURANCE}>
                <WithTooltip>
                    {title}
                    <TooltipInfo content={tooltipText} />
                </WithTooltip>
            </CellTitle>
            <CellPrice price={monthlyPrice} isMonthly={true} dataTest={ORDER_CART_TEST_ID.PRICE_INSURANCE} />
            <CellDetailSecondary>{note}</CellDetailSecondary>
            <RemoveAction onRemove={onRemove} isLoading={isLoading} isDisabled={isDisabled} />
        </InsuranceEntryListItem>
    );
};
